import React, { useMemo } from 'react';
import { HStack, MenuItemProps, Select, Text } from '@televet/kibble-ui';
import { Link } from 'react-router-dom';
import { WorkflowSendingHours as AutomationSendingHours } from 'shared/types/graphql';
import { formattedSendingHours } from 'pages/Automations';
import {
  AutomationsFieldDescription,
  AutomationsFieldLabel,
  AutomationsFieldContainer,
} from 'pages/Automations/components/Layout';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { updateAutomationDraft } from '../../../state/automationsSlice';

export const SendHours = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const sendHours = useAppSelector((state) => state.automations.automationDraft.sendHours);

  const handleSendHoursChange = ({ value }: MenuItemProps): void => {
    dispatch(updateAutomationDraft({ sendHours: value as AutomationSendingHours }));
  };

  const sendHoursOptions = useMemo(
    () => [
      {
        label: formattedSendingHours[AutomationSendingHours.All24Hours],
        value: AutomationSendingHours.All24Hours,
        isSelected: sendHours === AutomationSendingHours.All24Hours,
      },
      {
        label: formattedSendingHours[AutomationSendingHours.AutomationHours],
        value: AutomationSendingHours.AutomationHours,
        isSelected: sendHours === AutomationSendingHours.AutomationHours,
      },
      {
        label: formattedSendingHours[AutomationSendingHours.BusinessHours],
        value: AutomationSendingHours.BusinessHours,
        isSelected: sendHours === AutomationSendingHours.BusinessHours,
      },
    ],
    [sendHours],
  );

  return (
    <AutomationsFieldContainer>
      <AutomationsFieldLabel>Send Hours</AutomationsFieldLabel>
      <AutomationsFieldDescription>
        Send hours determine what day and time this automation is able to send. Automation Hours can be adjusted in{' '}
        <Link to="/settings/clinic/automations">
          <Text variant="interactive" textDecoration="underline">
            Settings
          </Text>
        </Link>
        .
      </AutomationsFieldDescription>

      <HStack>
        <Select
          value={sendHours}
          options={sendHoursOptions}
          listProps={{ onSelect: handleSendHoursChange, maxW: '100%' }}
        />
      </HStack>
    </AutomationsFieldContainer>
  );
};
